import { render } from "./ConfirmationGifts.vue?vue&type=template&id=19f982f2&scoped=true"
import script from "./ConfirmationGifts.vue?vue&type=script&lang=js"
export * from "./ConfirmationGifts.vue?vue&type=script&lang=js"

import "./ConfirmationGifts.vue?vue&type=style&index=0&id=19f982f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f982f2"]])

export default __exports__